import UserMenuConnected from './UserMenuConnected'

export default UserMenuConnected
